import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { createElement, useMemo, useState } from "react";
import { TbDotsVertical } from "react-icons/tb";

import { useTrackingActions } from "@/stores/use-tracking-table";
import { IPlanPassenger } from "@/types/tasks.types";

import {
    TrackingDetailClickActionNames,
    trackingDetailActions,
} from "../table/detailTable/TrackingDetailActionsColumn";

function MobileTrackingPassengerActions({
    passenger,
    totalPassengers,
}: {
    passenger: IPlanPassenger<"api">;
    totalPassengers: number;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { updateShowBulkUnassignDialog } = useTrackingActions();

    const open = Boolean(anchorEl);

    const clickActions: Partial<Record<TrackingDetailClickActionNames, { cb: () => void; cond: boolean }>> = useMemo(
        () => ({
            [TrackingDetailClickActionNames.PASSENGER_UNASSIGN]: {
                cb: async () => {
                    updateShowBulkUnassignDialog({
                        ids: [passenger.id],
                        totalPassengers,
                    });
                },
                cond: true,
            },
        }),
        [passenger, totalPassengers, updateShowBulkUnassignDialog]
    );

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const mobileActions = useMemo(
        () =>
            trackingDetailActions.filter(
                (action) => action.mobile && clickActions[action.onClick] && clickActions[action.onClick]?.cond
            ),
        [clickActions]
    );

    return (
        <>
            <IconButton onClick={handleClick} size="small" className=" !w-[30px] grow-0 shrink-0 !h-[30px]">
                <TbDotsVertical size={18} />
            </IconButton>
            <Menu
                sx={{
                    ":root": {},
                }}
                classes={{
                    paper: "!min-w-[178.58px]",
                    list: "!min-w-[178.58px]",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
            >
                {mobileActions.map((action) => (
                    <MenuItem key={action.label} onClick={clickActions[action.onClick]?.cb} sx={{}}>
                        <ListItemIcon>{createElement(action.icon, { color: action.color })}</ListItemIcon>
                        <ListItemText>{action.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default MobileTrackingPassengerActions;
